import { defineStyleConfig } from '@chakra-ui/react';

const Select = defineStyleConfig({
  variants: {
    outline: (props) => ({
      field: {
        bg: props.colorMode === 'dark' ? 'surface.darkContent' : 'surface.content',
        borderColor: props.colorMode === 'dark' ? 'gray.700' : 'line',
        _hover: {
          borderColor: props.colorMode === 'dark' ? 'gray.500' : 'gray.500',
        },
        _focus: {
          borderColor: 'brand.blue.500',
          boxShadow: 'focus',
        },
      },
      icon: {
        color: props.colorMode === 'dark' ? 'text.secondary' : 'gray.500',
      },
    }),
  },
  defaultProps: {
    variant: 'outline',
  },
});

export default Select;